export default __webpack_public_path__ + "static/media/event.2c6ae14d.svg";